import { StoreState } from '../../types';

const getState = (state: StoreState) => state.printRosters;
export const getIsPrinting = (state: StoreState) => getState(state).isPrinting;
export const getIsModalOpened = (state: StoreState) =>
  getState(state).isModalOpened;
export const getPrintOptions = (state: StoreState) => getState(state).options;
